import Footer1 from "./Footer1";
export default function Footer() {
  return (
    <>
      <Footer1 />
    </>
  );
}
